import { render, staticRenderFns } from "./guandao.vue?vue&type=template&id=b7ea8370&"
import script from "./guandao.vue?vue&type=script&lang=js&"
export * from "./guandao.vue?vue&type=script&lang=js&"
import style0 from "./guandao.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports